import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import ProjectForm from '../components/ProjectForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';



const CellActions = (props) =>{
    return(
        <>
            <Link to={`/project/details/${props.data.id}`}>{props.data.title}</Link>
            {/*

            <ProjectForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
  }


function ProjectDashboardPage() {

  const {userDD, customerDD, getDDDataById, getMasterLabel} = useAppData()
  const {projectList,getProjectList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        
        {headerName:"Action", width:"250", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getProjectList,
                remove:remove
            },
        },   

        {headerName: "Customer", width:250,
          valueGetter:params=>{
            return getDDDataById(customerDD,params.data.customerId).label;
          }
        },
        {headerName: "Project Manager", width:250,
          valueGetter:params=>{
            return getDDDataById(userDD,params.data.managerId).label;
          }
        },
        {headerName: "Created By", width:250,
          valueGetter:params=>{
            return getDDDataById(userDD,params.data.userId).label;
          }
        },
           
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Projects</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><ProjectForm callBack={getProjectList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={projectList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getProjectList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default ProjectDashboardPage